import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import whizeosupportToolsStore from './state';
import authStore from './authStore';
import roles from './roles';
import clientStore from './clients';
import healthScoreStore from './healthScore';

export default new Vuex.Store({
    modules: {
        whizeosupportToolsStore,
        clientStore,
        authStore,
        roles,
        healthScoreStore,
    }
});
